let menu = document.querySelector('.nav__mobile')

function showMenu () {
  this.parentElement.classList.toggle('is-active')
}

menu.addEventListener('click', showMenu)
